import { useEffect, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { InsightViewType, InsightViewDataSetType } from 'constant/ViewConstant';
import { ToggleButtonGroupSX } from 'utils/CommonSx';
import { Stack, Typography } from '@mui/material';

const options = [
  {
    label: 'For Reporting',
    value: InsightViewType.REPORT,
  },
  {
    label: 'For Charting',
    value: InsightViewType.CHART,
  },
];

const dataSetTypeOptions = [
  {
    label: 'Individual Data Set',
    value: InsightViewDataSetType.INDIVIDUAL_DATA_SET,
  },
  {
    label: 'Combined Data Set',
    value: InsightViewDataSetType.COMBINED_DATA_SET,
  },
];

interface InsightViewTypeProps {
  value?: string | null;
  dataSetTypeValue?: string | null;
  onChange?: (value: string) => void;
  onDataSetTypeChange?: (value: string) => void;
  disabled?: boolean;
}

export const InsightViewTypeComponent = (props: InsightViewTypeProps) => {
  const { value, dataSetTypeValue, onChange, onDataSetTypeChange, disabled } = props;

  const [selectedType, setSelectedType] = useState(InsightViewType.REPORT);
  const [selectedDataSetType, setSelectedDataSetType] = useState(InsightViewDataSetType.INDIVIDUAL_DATA_SET);

  const handleChange = (event: React.MouseEvent<HTMLElement>, selectedInsightType: string) => {
    if (selectedInsightType === null) return;

    setSelectedType(selectedInsightType);
    onChange?.(selectedInsightType);

    // If changing to REPORT type, automatically set dataSetType to INDIVIDUAL_DATA_SET
    if (selectedInsightType === InsightViewType.REPORT) {
      setSelectedDataSetType(InsightViewDataSetType.INDIVIDUAL_DATA_SET);
      onDataSetTypeChange?.(InsightViewDataSetType.INDIVIDUAL_DATA_SET);
    }
  };

  const handleDataSetTypeChange = (event: React.MouseEvent<HTMLElement>, selectedDataSetTypeValue: string) => {
    if (selectedDataSetTypeValue === null) return;

    setSelectedDataSetType(selectedDataSetTypeValue);
    onDataSetTypeChange?.(selectedDataSetTypeValue);
  };

  useEffect(() => {
    if (value) {
      setSelectedType(value);
    }
  }, [value]);

  useEffect(() => {
    if (dataSetTypeValue) {
      setSelectedDataSetType(dataSetTypeValue);
    }
  }, [dataSetTypeValue]);

  return (
    <div>
      <div style={{ marginBottom: '8px' }}>
        <ToggleButtonGroup
          color='primary'
          disabled={disabled}
          value={selectedType}
          exclusive
          onChange={handleChange}
          sx={ToggleButtonGroupSX.buttonGroup}
        >
          {options.map((option) => (
            <ToggleButton key={option.value} value={option.value} size='small'>
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>

      {selectedType === InsightViewType.CHART && (
        <div style={{ marginTop: '8px' }}>
          <Stack>
            <Typography variant='input-label' fontWeight={800}>
              Select Data Set Type
            </Typography>
            <Typography variant='input-label-gray' fontSize={13}>
              Choose the data set type.
            </Typography>
          </Stack>
          <ToggleButtonGroup
            color='primary'
            disabled={disabled}
            value={selectedDataSetType}
            exclusive
            onChange={handleDataSetTypeChange}
            sx={ToggleButtonGroupSX.buttonGroup}
          >
            {dataSetTypeOptions.map((option) => (
              <ToggleButton key={option.value} value={option.value} size='small'>
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      )}
    </div>
  );
};
